// Linkification for message text (Discussions). Pure and strict: only
// http(s) — and www.-prefixed — ever become links; everything else stays
// text. Rendering goes through React's escaping; this module never
// produces HTML, only segments.

export interface Segment {
  kind: 'text' | 'link';
  value: string;
  /** Absolute href for link segments (www. gets https://). */
  href?: string;
}

const URL_RE = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;
// Punctuation that ends a sentence more often than a URL.
const TRAILING = /[.,!?;:]+$/;

export function splitLinks(text: string): Segment[] {
  const out: Segment[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_RE)) {
    let raw = match[0];
    const start = match.index;
    // Trim sentence punctuation, and a closing paren with no opener inside.
    raw = raw.replace(TRAILING, '');
    while (raw.endsWith(')') && (raw.match(/\(/g) ?? []).length < (raw.match(/\)/g) ?? []).length) {
      raw = raw.slice(0, -1);
    }
    if (raw.length < 4) continue;
    if (start > last) out.push({ kind: 'text', value: text.slice(last, start) });
    out.push({
      kind: 'link',
      value: raw,
      href: raw.toLowerCase().startsWith('www.') ? `https://${raw}` : raw,
    });
    last = start + raw.length;
  }
  if (last < text.length) out.push({ kind: 'text', value: text.slice(last) });
  return out.length ? out : [{ kind: 'text', value: text }];
}
